<template>
  <div class="modal animated is-active">
    <div class="modal-background"></div>
    <div class="modal-card is-large">
      <header class="modal-card-head">
        <p class="modal-card-title">{{ title }}</p>
      </header>
      <section class="modal-card-body">
        <div class="notification is-danger" v-if="error !== ''">{{ error }}</div>
        <div class="control is-vertical">
          <div class="control is-grouped">
            <p class="control is-expanded">
              <label class="label">Departament</label>
              <select class="select is-fullwidth" v-model="comment.department" name="department" id="department" :class="{'is-danger': errors.has('department') }" v-validate="'required'">
                <option v-for="department in context.$store.state.config.departaments" v-bind:value="department.id">{{ department.name }}</option>
              </select>
              <span v-show="errors.has('receiving_extension')" class="help is-danger">{{ errors.first('receiving_extension') }}</span>
            </p>
          </div>
          <p class="control is-expanded">
            <label class="label">Comment</label>
            <textarea :class="{'textarea': true, 'is-danger': errors.has('comment') }" name="comment" id="comment" v-model="comment.comment" v-validate="'required'"></textarea>
            <span v-show="errors.has('comment')" class="help is-danger">{{ errors.first('comment') }}</span>
          </p>
        </div>
        <div class="control is-vertical">
          <div class="control">
            <vue-dropzone ref="dropzone" id="dropzone" :options="dropzoneOptions" @vdropzone-queue-complete="vdSuccess" @vdropzone-sending="vdSendingEvent"></vue-dropzone>
          </div>
        </div>
      </section>
      <footer class="modal-card-foot">
        <div class="control is-grouped is-pulled-right">
          <p class="control is-pulled-right">
            <a :class="{'button': true, 'is-primary': true, 'is-disabled': inProgress}" @click="close(true)">Close</a>
          </p>
          <p class="control">
            <a :class="{'button': true, 'is-success': true, 'is-disabled': errors.any(), 'is-loading': inProgress}" @click="save">Save</a>
          </p>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
  import vue2Dropzone from 'vue2-dropzone'
  import 'vue2-dropzone/dist/vue2Dropzone.min.css'
  export default {
    props: {
      context: {
        type: Object
      },
      parent: {
        type: Object
      },
      callback: {
        type: String
      },
      title: {
        type: String
      },
      id: {
        type: Number
      },
      chain_id: {
        type: Number,
        default: null
      },
      provider_id: {
        type: Number,
        default: null
      },
      agency_id: {
        type: Number,
        default: null
      },
      hotel_id: {
        type: Number,
        default: null
      },
      edit: {
        type: Boolean
      }
    },
    data () {
      return {
        comment: {
          chain_id: null,
          agency_id: null,
          base_id: null,
          provider_id: null,
          hotel_id: null,
          department: 1,
          comment: '',
          attachments: 0
        },
        dropzoneOptions: {
          url: this.context.$store.state.config.apiURL + '/comments/files',
          maxFilesize: 10,
          acceptedFiles: 'image/*,application/pdf,.doc,.docx,.csv,.xls,.xlsx,.txt,.eml,.log,.xml,.json',
          autoProcessQueue: false,
          dictDefaultMessage: 'Upload Files (max size 10MB)',
          headers: {
            'Authorization': 'Bearer ' + this.context.$store.state.config.token.access_token
          },
          addRemoveLinks: true
        },
        inProgress: false,
        error: ''
      }
    },
    mounted () {
      this.$nextTick(() => {
        if (this.edit) {
          this.loadData()
        } else {
          document.body.appendChild(this.$el)
        }
      })
    },
    methods: {
      close (closeOnly) {
        if (!closeOnly) {
          this.parent[this.callback]()
        }
        this.$el.remove()
      },
      save () {
        this.$validator.validateAll().then(() => {
          this.inProgress = true
          this.error = ''
          this.comment.chain_id = this.chain_id
          this.comment.provider_id = this.provider_id
          this.comment.agency_id = this.agency_id
          this.comment.hotel_id = this.hotel_id
          this.inProgress = true
          if (this.$refs.dropzone.getQueuedFiles().length > 0) {
            this.comment.attachments = 1
          }
          if (!this.edit) {
            this.context.$http.post(this.context.$store.state.config.apiURL + '/comments', this.comment).then((response) => {
              if (this.$refs.dropzone.getQueuedFiles().length > 0) {
                this.$refs.dropzone.processQueue()
              } else {
                this.close(false)
              }
              this.inProgress = false
              this.close(false)
            }, (response) => {
              this.inProgress = false
              this.error = response.body
            })
          } else {
            this.context.$http.post(this.context.$store.state.config.apiURL + '/comments/' + this.id, this.comment).then((response) => {
              this.inProgress = false
              this.close(false)
            }, (response) => {
              this.inProgress = false
              this.error = response.body
            })
          }
        })
      },
      loadData () {
        this.context.$http.get(this.context.$store.state.config.apiURL + '/comments/' + this.id).then((response) => {
          this.call = response.body
          document.body.appendChild(this.$el)
        }, (response) => {

        })
      },
      vdSuccess (file, xhr, formData) {
        this.$emit('reload')
        this.inProgress = false
        this.close(false)
      },
      vdSendingEvent (file, xhr, formData) {
        if (this.chain_id) {
          formData.append('provider_id', this.chain_id)
        } else if (this.provider_id) {
          formData.append('provider_id', this.provider_id)
        } else if (this.agency_id) {
          formData.append('agency_id', this.agency_id)
        } else if (this.hotel_id) {
          formData.append('hotel_id', this.hotel_id)
        }
      }
    },
    computed: {
      enterClass () {
        return `${this.transition}In`
      },
      leaveClass () {
        return `${this.transition}Out`
      }
    },
    components: {
      vueDropzone: vue2Dropzone
    }
  }
</script>
<style lang="scss" scoped>
  #dropzone .dz-success-mark, .dz-error-mark, .dz-remove {
    display: none;
  }
  .is-title {
    text-transform: capitalize;
  }

  .panel {
    background-color: white;
    box-shadow: 0px 2px 3px rgb(167, 28, 32), 0px 0px 0px 1px rgb(167, 28, 32);
    color: #4a4a4a;
    max-width: 100%;
    position: relative;
    border: 0px;
    border-radius: 0px;
  }

  .panel-heading {
    color: #FFFFFF;
    font-weight: bold;
    -ms-flex-align: stretch;
    align-items: stretch;
    display: -ms-flexbox;
    display: flex;
    min-height: 40px;
    box-shadow: 0px 1px 0px rgb(167, 28, 32), 0px 0px 0px 0px rgb(167, 28, 32);
    background-color: rgb(167, 28, 32);
    border-bottom: 0px;
    border-radius: 0px;
    font-size: 1rem;
  }

  .modal-card-body {
    min-height: 300px;
  }
</style>



// WEBPACK FOOTER //
// Comment.vue?6f885ebb